import connection from '~services/connectionModule';

/** `handleRequestError` rethrows by design; this swallows it instead. */
export default function reportRequestError(error: unknown, message: string) {
  try {
    connection.handleRequestError(error, message);
  } catch {
    // Swallowed on purpose; handleRequestError has already toasted and reported to Sentry.
  }
}
